import React, { Component } from 'react'
import { Field, reduxForm } from 'redux-form'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import { authenticateUser } from '../../actions/util/authenticationJwtActions'
import ModalEsqueciMinhaSenha from './ModalEsqueciMinhaSenha';
import ModalEsqueciMinhaSenhaMobile from './ModalEsqueciMinhaSenhaMobile'
import ReCaptchaV2 from 'react-google-recaptcha'
import { AUTHENTICATION_FAILED } from '../../actions/types';
import imgColunaEsq from '../../img/escritorio-vexado.webp';
import imgLogoBranca from '../../img/logo-branco-01.png';

const WA_LINK = 'https://wa.me/5561981537600?text=Ol%C3%A1%2C%20vim%20pelo%20site%20e%20quero%20mais%20informa%C3%A7%C3%B5es.';
const SITE_LINK = 'https://vexado.com.br/';
const RECAPTCHA_KEY = '6LfNrvkdAAAAAL2wVMaGIuOwJ0STFzIOavTKhNvw';

const renderFieldLogin = (field) => {
  const { meta: { touched, error } } = field;
  return (
    <div>
      <input
        className={`vx-login-input${touched && error ? ' vx-login-input--error' : ''}`}
        id={field.id}
        style={{ textTransform: field.type === 'password' ? 'none' : 'lowercase' }}
        type={field.type}
        placeholder={field.placeholder}
        autoComplete={field.autoComplete}
        {...field.input}
        autoFocus={field.input.name === 'username'}
      />
      {touched && error && <span className="vx-login-error">{error}</span>}
    </div>
  );
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = { chaveCaptcha: null };
    this.recaptchaRef = React.createRef();
  }

  // Marca o <body> enquanto o login está na tela: o CSS usa isso para anular, só aqui,
  // o espaço do header fixo e o padding lateral dos wrappers das páginas públicas
  // (.app-body / .main > .container-fluid), deixando o login em tela inteira no mobile.
  componentDidMount() {
    document.body.classList.add('vx-login-ativo');
  }

  componentWillUnmount() {
    document.body.classList.remove('vx-login-ativo');
  }

  changeRecaptcha(value) {
    if (value) this.setState({ chaveCaptcha: value });
  }

  onSubmit(values) {
    this.props.authenticateUser({
      username: values.username.toLowerCase().trim(),
      password: values.password,
      chaveCaptcha: this.state.chaveCaptcha
    }).then((resp) => {
      if (resp.type === AUTHENTICATION_FAILED) {
        this.setState({ chaveCaptcha: null });
        if (this.recaptchaRef.current) this.recaptchaRef.current.reset();
      }
    });
  }

  renderCTA() {
    return (
      <div className="vx-login-cta">
        <p className="vx-login-cta__label">
          Contrate agora para sua empresa
        </p>
        {this.ctaBtns()}
      </div>
    );
  }

  ctaBtns() {
    return (
      <>
        <a href={SITE_LINK} target="_blank" rel="noopener noreferrer"
           className="vx-login-cta-btn vx-login-cta-btn--site">
          <i className="material-icons">language</i>
          Conheça o sistema Vexado
        </a>
        <a href={WA_LINK} target="_blank" rel="noopener noreferrer"
           className="vx-login-cta-btn vx-login-cta-btn--whatsapp">
          <i className="material-icons">chat</i>
          Falar pelo WhatsApp
        </a>
      </>
    );
  }

  render() {
    const { from } = this.props.location.state || { from: { pathname: '/' } };
    const { isAuthenticated, habilitadoAutenticacaoDoisFatores, habilitadoAceiteAutenticacaoDoisFatores } = this.props.authentication;

    if (habilitadoAceiteAutenticacaoDoisFatores && habilitadoAutenticacaoDoisFatores) {
      return <Redirect to='/painel-autenticacao-dois-fatores' />;
    }
    if (isAuthenticated) {
      return <Redirect to={from} />;
    }

    const { handleSubmit } = this.props;

    return (
      <div className="vx-login-page">

        {/* ── Painel esquerdo: brand + CTA (desktop) ── */}
        <div
          className="vx-login-left"
          style={{ backgroundImage: `url(${imgColunaEsq})` }}
        >
          <div className="vx-login-left__overlay">
            <div className="vx-login-left__content">
              <img src={imgLogoBranca} alt="Vexado" className="vx-login-brand-logo" />
              <h2 className="vx-login-brand-title">
                Gestão inteligente para empresas de transporte
              </h2>
              <p className="vx-login-brand-subtitle">
                Controle passagens, roteiros, financeiro e muito mais em um único sistema. Simples, rápido e confiável.
              </p>
              {this.renderCTA()}
            </div>
          </div>
        </div>

        {/* ── Painel direito: formulário ── */}
        <div className="vx-login-right">
          <div className="vx-login-form-wrap">

            {/* Logo visível só no mobile */}
            <div className="vx-login-mobile-logo">
              <img src={imgLogoBranca} alt="Vexado" />
            </div>

            <h1 className="vx-login-title">Fazer login</h1>
            <p className="vx-login-subtitle">Bem-vindo de volta ao Vexado</p>

            <form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
              <div className="vx-login-field">
                <label className="vx-login-label" htmlFor="username">Usuário</label>
                <div className="vx-login-input-wrap">
                  <i className="material-icons vx-login-input-icon">person</i>
                  <Field
                    name="username"
                    type="text"
                    id="username"
                    placeholder="Digite seu usuário"
                    autoComplete="username"
                    component={renderFieldLogin}
                  />
                </div>
              </div>

              <div className="vx-login-field">
                <label className="vx-login-label" htmlFor="password">Senha</label>
                <div className="vx-login-input-wrap">
                  <i className="material-icons vx-login-input-icon">lock</i>
                  <Field
                    name="password"
                    id="password"
                    type="password"
                    placeholder="Digite sua senha"
                    autoComplete="current-password"
                    component={renderFieldLogin}
                  />
                </div>
              </div>

              <div className="vx-login-forgot">
                <span
                  data-toggle="modal"
                  data-target="#modalEsqueciMinhaSenha"
                >
                  Esqueci minha senha
                </span>
              </div>

              <button
                id="btn-entrar"
                type="submit"
                className="vx-login-btn"
                disabled={!this.state.chaveCaptcha}
              >
                <i className="material-icons">arrow_forward</i>
                ENTRAR
              </button>

              <div className="vx-login-captcha">
                <ReCaptchaV2
                  ref={this.recaptchaRef}
                  style={{ display: 'inline-block' }}
                  sitekey={RECAPTCHA_KEY}
                  onChange={(value) => this.changeRecaptcha(value)}
                  onExpired={() => this.setState({ chaveCaptcha: null })}
                  onErrored={() => this.setState({ chaveCaptcha: null })}
                />
              </div>
            </form>
          </div>

          <ModalEsqueciMinhaSenha />
          <ModalEsqueciMinhaSenhaMobile />
        </div>
      </div>
    );
  }
}

function validate(values) {
  const errors = {};
  if (!values.username) errors.username = 'Por favor, informe o usuário';
  if (!values.password) errors.password = 'Por favor, informe a senha';
  return errors;
}

const mapStateToProps = ({ authentication }) => ({ authentication });
const reduxConnectEnhance = connect(mapStateToProps, { authenticateUser })(Login);

export default reduxForm({
  validate,
  form: 'LoginForm'
})(reduxConnectEnhance);
